import { Routes } from '@angular/router';
import { authGuard } from '../../core/guards';

export const personsRoutes: Routes = [
  {
    path: 'persons',
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./components/list/person-list.component').then((m) => m.PersonListComponent),
      },
      {
        path: 'create',
        redirectTo: 'new',
        pathMatch: 'full',
      },
      {
        path: 'new',
        loadComponent: () =>
          import('./components/create/person-create.component').then(
            (m) => m.PersonCreateComponent
          ),
        canActivate: [authGuard],
      },
      {
        path: ':id',
        loadComponent: () =>
          import('./components/detail/person-detail.component').then(
            (m) => m.PersonDetailComponent
          ),
      },
      {
        path: ':id/edit',
        loadComponent: () =>
          import('./components/edit/person-edit.component').then((m) => m.PersonEditComponent),
        canActivate: [authGuard],
      },
    ],
  },
];
